import { STATS_API } from "@/lib/constants";
import { cn, formatViews } from "@/lib/utils";
import { useQuery } from "@tanstack/react-query";
import Skeleton from "react-loading-skeleton";
import Image from "next/image";

const fetchStats = async () => {
	try {
		const url = new URL(STATS_API);

		url.searchParams.set("query", "discussion-board-stats");
		url.searchParams.set("page", "discussion-board");

		const response = await fetch(url);
		const data = await response.json();

		return {
			numberOfDiscussionPosts: 752,
			numberOfChannelMembers: 6367,
			numberOfViews: data?.numberOfViews || 0,
		};
	} catch (error) {
		console.log("Error occured while fetching stats, error: ", error);

		return {
			numberOfDiscussionPosts: 0,
			numberOfChannelMembers: 0,
			numberOfViews: 0,
		};
	}
};

const LeadingOnlineForumStats = ({ className }: { className?: string }) => {
	const { isLoading, data } = useQuery({
		queryKey: ["discussionBoardStats"],
		queryFn: fetchStats,
		refetchOnWindowFocus: false,
	});

	return (
		<div
			className={cn(
				"mx-auto flex w-fit items-center justify-center gap-4 rounded-xl  px-4 py-2 text-left sm:gap-8 sm:px-6 sm:py-4",
				className
			)}
		>
			{isLoading ? (
				<div>
					<Skeleton count={2} className="h-5 w-10 sm:w-20" />
				</div>
			) : (
				<div className="space-y-1 text-center">
					<h5 className="text-xl font-semibold text-white sm:text-2xl">
						{data?.numberOfDiscussionPosts}+
					</h5>
					<span className="block text-xs font-medium text-white sm:text-sm">Posts</span>
				</div>
			)}

			<div className="w-px self-stretch bg-gray-300" />

			{isLoading ? (
				<div>
					<Skeleton count={2} className="h-5 w-10 sm:w-20" />
				</div>
			) : (
				<div className="space-y-1 text-center">
					<span className="text-xl font-semibold text-white sm:text-2xl">
						{data?.numberOfChannelMembers}+
					</span>
					<span className="block text-xs font-medium text-white sm:text-sm">Members</span>
				</div>
			)}

			<div className="w-px self-stretch bg-gray-300" />

			{isLoading ? (
				<div>
					<Skeleton count={2} className="h-5 w-10 sm:w-20" />
				</div>
			) : (
				<div className="space-y-1 text-center">
					<span className="text-xl font-semibold text-yellow-500 sm:text-2xl">757+</span>
					<div className="flex items-center gap-2">
						<Image
							src={`${process.env.NEXT_PUBLIC_ASSETS_BASE_PREFIX}/static-files/home/leading-online-forum/vip-crown-icon.png`}
							alt="VIP Crown Icon"
							width={80}
							height={80}
							className="h-4 w-4"
						/>
						<span className="block text-xs font-medium text-yellow-500 sm:text-sm">
							VIP Members
						</span>
					</div>
				</div>
			)}

			<div className="w-px self-stretch bg-gray-300" />

			{isLoading ? (
				<div>
					<Skeleton count={2} className="h-5 w-10 sm:w-20" />
				</div>
			) : (
				<div className="space-y-1 text-center">
					<span className="text-xl font-semibold text-white sm:text-2xl">
						{formatViews(data?.numberOfViews)}
					</span>
					<span className="block text-xs font-medium text-white sm:text-sm">Views</span>
				</div>
			)}
		</div>
	);
};

export default LeadingOnlineForumStats;
